"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromProcess = void 0;
const credential_provider_process_1 = require("@aws-sdk/credential-provider-process");
const fromProcess = (init) => (0, credential_provider_process_1.fromProcess)(init);
exports.fromProcess = fromProcess;
